/**
 * PatientReportPrint - Print view wrapper for patient reports
 * 
 * Pulls params from route and renders the UserReportPrint component.
 */

import { useContext } from "react";
import { useParams, useHistory } from "react-router-dom";

import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";
import { ViewerContext } from "@/tpo/Viewer";
import { UserReportPrint } from "@/components/reports/print";
import { CMP_PATIENTS_REPORT_TAB_URL, getCmpUrl } from "@/core/urls";

import {
  PATIENT_USER_REPORT_PRINT_QUERY,
  PATIENT_USER_RESULT_PRINT_DETAILS_QUERY
} from "./graphql/printQueries";

export default function PatientReportPrint() {
  const history = useHistory();
  const { patientId, reportSlug } = useParams();
  const { organisationId, organisation } = useOrganisationContext();
  const { userId } = useContext(ViewerContext);

  const handleClose = () => {
    // Go back to the report overview
    history.push(
      getCmpUrl(CMP_PATIENTS_REPORT_TAB_URL, {
        organisationId: organisation?.hashId,
        patientId,
        reportSlug,
        tab: "overview"
      })
    );
  };

  if (!organisationId || !userId) {
    return <div>Loading...</div>;
  }

  return (
    <UserReportPrint
      userId={userId}
      organisationId={organisationId}
      reportSlug={reportSlug}
      reportPrintQuery={PATIENT_USER_REPORT_PRINT_QUERY}
      userResultPrintDetailsQuery={PATIENT_USER_RESULT_PRINT_DETAILS_QUERY}
      onClose={handleClose}
    />
  );
}
